var exports = {
  "lF": "ActionList__UyyzLI",
  "qv": "emptyStateMessage__XzWJpn",
  "ri": "CopilotRepoSelectPanelAnchored__h1XEGm",
};

module.exports = exports;
